<template lang="pug">
  .marker-info-window.xs-f-xsmall.max-at-tweak.pb-2
    .name.bold.mt-5.mb-5.xs-f-small.max-at-tweak {{ location.name }}
    .address.mb-5
      .address-line.xs-f-xsmall.max-at-tweak(v-if="location.shortAddress") {{ location.shortAddress }}

      template(v-else)
        .address-line.xs-f-xsmall.max-at-tweak {{ location.address1 }}
        .address-line.xs-f-xsmall.max-at-tweak {{ location.address2 }}
        .address-line.xs-f-xsmall.max-at-tweak {{ location.city }}, {{location.state}} {{location.zip}}

    a.phone.upper.mt-5.mb-5.xs-f-xsmall.max-at-tweak(:href="`tel:${location.phone}`") {{ location.phone }}
    .cta-wrap
      a.view-details-btn.btn-link.underline.mt-5.mb-5.xs-f-xsmall.max-at-tweak(:href="`/colorbar/locations/${location.code}`") View Details
      button.mr-btn.xs-f-xxsmall.max-at-tweak(@click="trackMREventAndRedirect('HCB Locations Page - Map Book Now clicked',`/colorbar/booking/${location.code}/services`)") Book Now

</template>

<script>
  export default {
    name: 'MarkerInfoWindow',

    props: {
      location: {
        type: Object,
        required: true,
      },
    },

    methods: {
      onCtaClicked() {
        this.trackEvent(`Book Service CTA Clicked`, {
          locationCode: this.location.code,
          locationName: this.location.name,
        });
      },
    },

  };
</script>

<style lang="stylus">
  .marker-info-window
    display flex
    flex-direction column
    .address
      display flex
      flex-direction column
    .phone
      text-decoration: inherit
    .view-details-btn
      text-align left
    .cta-wrap
      display flex
      justify-content space-between
      .mr-btn
        font-size xx-small
        padding 0.5em 1em
</style>